import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * Create a simple registry for toolbar components.
 *
 * @returns A registry object with a `register` method and a `components` array.
 *
 * @example
 * ```ts
 * const registry = createToolbarRegistry();
 *
 * registry.register([
 * 	{
 * 		type: 'toolbar',
 * 		key: 'primary-toolbar',
 * 		component: ({ children }) => <div>{children}</div>,
 * 	},
 *  {
 *      type: 'section',
 *      key: 'section-1',
 *      rank: 1,
 *      parents: [{ type: 'toolbar', key: 'primary-toolbar' }],
 *      component: ({ children }) => <div>{children}</div>,
 *  },
 *  {
 *      type: 'group',
 *      key: 'group-1',
 *      rank: 1,
 *      parents: [{ type: 'section', key: 'section-1' }],
 *      component: ({ children }) => <div>{children}</div>,
 *  },
 * ]);
 */
export var createComponentRegistry = function createComponentRegistry() {
  var components = [];
  var register = function register(newComponents) {
    components.push.apply(components, _toConsumableArray(newComponents));
  };
  return {
    register: register,
    components: components
  };
};